import React, { Component } from 'react';
import classNames from 'classnames';
import { SkyLightStateless } from 'react-skylight';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, DropdownButton, MenuItem, Breadcrumb } from 'react-bootstrap';
import { Field } from 'redux-form';
import { Translate } from 'react-redux-i18n';
import { CSVLink } from 'react-csv';
import _ from 'lodash';
import moment from 'moment';

import CtRowRenderer from '../Common/ctRowRenderer';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { UI_HEIGHT } from '../Common/constants';
import Spinner from '../../components/Widgets/spinner';
import { DatePicker, DisabledDatePicker } from '../Common/datePicker';
import { DisabledInputField } from '../Common/inputField';
import { Selection } from '../Common/selection';
import ConfirmActionModal from '../Common/confirmActionModal';
import CashFormatter from '../Common/cashFormatter';
import PercentFormatter from '../Common/percentFormatter';
import { numberWithCommas } from '../Common/numberWithCommas';
import { formatExportData } from './salesInvoiceExport';
import { toFromDates } from '../Common/cleanDates';
import GenericDatePicker from '../Common/GenericDatePicker';
import genericRadioFilter from '../Common/genericRadioFilter';
import TypeRadios from '../../containers/Common/TypeRadios';
import { ROOT_URL, ROOT_API_URL, companyCodeTitle, isOCM, isHMM, isOLG, isCPG, isDAICHEONG } from '../../actions/root_url';
import GenericProductSuggest from '../../containers/Common/GenericProductSuggest';
import PrintIframe from '../Common/PrintIframe';
import checkPermission from '../Common/permissions';
import dateFilterRadios from '../Common/dateFilterRadios';
import VerifyPasscodeModal from '../Common/VerifyPasscodeModal';
import PaymentMethodModal from './PaymentMethodModal';

const isTN =
  ROOT_API_URL === "https://tn-scm.truckxi.com/api/" ||
  ROOT_URL === "https://tn-scm.truckxi.com/api/";
const isEcity = ROOT_API_URL === 'https://dev-scm.truckxi.com/api/' || ROOT_API_URL === 'https://ct-scm.truckxi.com/api/';
const isRivera = ROOT_API_URL === 'https://rivera-scm.truckxi.com/api/' || ROOT_URL === 'https://rvrstage-scm.truckxi.com/api/';
const getBsStyle = (input, value) => (input === value ? 'success' : 'primary');

let renderRadios = (props) => {
  const renderStartDatePicker = (days) => {
    if (days === -1) {
      return (
        <Button bsStyle="primary" disabled={props.fetching}>
          <Field name="FromDate" placeholder="Start" component={DatePicker} />
        </Button>
      );
    }
    return (
      <Button bsStyle="primary" disabled={props.fetching}>
        <Field name="FromDate" placeholder="Start" component={DisabledDatePicker} />
      </Button>
    );
  };
  const renderEndDatePicker = (days) => {
    if (days === -1) {
      return (
        <Button bsStyle="primary" disabled={props.fetching}>
          <Field name="ToDate" placeholder="End" component={DatePicker} />
        </Button>
      );
    }
    return (
      <Button bsStyle="primary" disabled={props.fetching}>
        <Field name="ToDate" placeholder="End" component={DisabledDatePicker} />
      </Button>
    );
  };
  if (props.page === 'salesInvoice') {
    return (
      <ButtonToolbar className="radio-filter-buttons">
        <Button bsStyle={getBsStyle(props.input.value, '1')} disabled={props.fetching}>
          <div className="radio">
            <label htmlFor="today-radio-filter">
              <input {...props.input} id="today-radio-filter" type="radio" name="dateFilterRadios" value="1" onClick={() => { props.fetchSalesInvoicesByDetails('1'); }} checked={props.input.value === '1'} />
              <Translate value="today" />
            </label>
          </div>
        </Button>
        <Button bsStyle={getBsStyle(props.input.value, '7')} disabled={props.fetching}>
          <div className="radio">
            <label htmlFor="sevenDay-radio-filter">
              <input {...props.input} id="sevenDay-radio-filter" type="radio" name="dateFilterRadios" value="7" onClick={() => { props.fetchSalesInvoicesByDetails('7'); }} checked={props.input.value === '7'} />
              7 <Translate value="days" />
            </label>
          </div>
        </Button>
        <Button bsStyle={getBsStyle(props.input.value, '30')} disabled={props.fetching}>
          <div className="radio">
            <label htmlFor="thirtyDay-radio-filter">
              <input {...props.input} id="thirtyDay-radio-filter" type="radio" name="dateFilterRadios" value="30" onClick={() => { props.fetchSalesInvoicesByDetails('30'); }} checked={props.input.value === '30'} />
            30 <Translate value="days" />
            </label>
          </div>
        </Button>
        <Button bsStyle={getBsStyle(props.input.value, '90')} disabled={props.fetching}>
          <div className="radio">
            <label htmlFor="ninetyDay-radio-filter">
              <input {...props.input} id="ninetyDay-radio-filter" type="radio" name="dateFilterRadios" value="90" onClick={() => { props.fetchSalesInvoicesByDetails('90'); }} checked={props.input.value === '90'} />
            90 <Translate value="days" />
            </label>
          </div>
        </Button>
        <Button bsStyle={getBsStyle(props.input.value, ' -1')} disabled={props.fetching}>
          <div className="radio">
            <label htmlFor="dateRange-radio-filter">
              <input {...props.input} id="dateRange-radio-filter" type="radio" name="dateFilterRadios" value="-1" checked={props.input.value === '-1'} />
              <Translate value="date_range" />
            </label>
          </div>
        </Button>
        {renderStartDatePicker(props.Days)}
        {renderEndDatePicker(props.Days)}
      </ButtonToolbar>
    );
  }
  // return (
  // <ButtonToolbar className="radio-filter-buttons">
  //   {renderStartDatePicker(props.Days)}
  //   {renderEndDatePicker(props.Days)}
  //   <Button
  //     bsStyle="primary"
  //     className="search-btn"
  //     type="submit"
  //     onClick={() => { props.fetchSalesInvoicesByDetails(); }}
  //     disabled={props.fetching}
  //   >
  //     <em className="fa fa-search" />
  //   </Button>
  // </ButtonToolbar>
  // );
};

const renderTypeRadios = (props) => {
  return (
    <ButtonToolbar className="radio-filter-buttons">
      <Button bsStyle={getBsStyle(props.input.value, 'all')} disabled={props.fetching}>
        <div className="radio">
          <label htmlFor="all-radio-filter">
            <input {...props.input} id="all-radio-filter" type="radio" name="typeFilterRadios" value="all" checked={props.input.value === 'all'} />
            <Translate value="all" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, 'invoices')} disabled={props.fetching}>
        <div className="radio">
          <label htmlFor="invoices-radio-filter">
            <input {...props.input} id="invoices-radio-filter" type="radio" name="typeFilterRadios" value="invoices" checked={props.input.value === 'invoices'} />
            <Translate value="sales" />
          </label>
        </div>
      </Button>
      {/* {!isDAICHEONG &&  */}
      <Button bsStyle={getBsStyle(props.input.value, 'returns')} disabled={props.fetching}>
        <div className="radio">
          <label htmlFor="returns-radio-filter">
            <input {...props.input} id="returns-radio-filter" type="radio" name="typeFilterRadios" value="returns" checked={props.input.value === 'returns'} />
            <Translate value="returns" />
          </label>
        </div>
      </Button>
{/* } */}
    </ButtonToolbar>
  );
};

const renderStatusRadios = (props) => {
  return (
    <ButtonToolbar className="radio-filter-buttons">
      <Button bsStyle={getBsStyle(props.input.value, 'all')} disabled={props.fetching}>
        <div className="radio">
          <label htmlFor="all-status-radio-filter">
            <input {...props.input} id="all-status-radio-filter" type="radio" name="statusFilterRadios" value="all" checked={props.input.value === 'all'} />
            <Translate value="all" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, 'Released')} disabled={props.fetching}>
        <div className="radio">
          <label htmlFor="released-radio-filter">
            <input {...props.input} id="released-radio-filter" type="radio" name="statusFilterRadios" value="Released" checked={props.input.value === 'Released'} />
            <Translate value="released" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, 'Finalized')} disabled={props.fetching}>
        <div className="radio">
          <label htmlFor="finalized-radio-filter">
            <input {...props.input} id="finalized-radio-filter" type="radio" name="statusFilterRadios" value="Finalized" checked={props.input.value === 'Finalized'} />
            <Translate value="finalized" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, 'Void')} disabled={props.fetching}>
        <div className="radio">
          <label htmlFor="void-radio-filter">
            <input {...props.input} id="void-radio-filter" type="radio" name="statusFilterRadios" value="Void" checked={props.input.value === 'Void'} />
            <Translate value="void" />
          </label>
        </div>
      </Button>
    </ButtonToolbar>
  );
};

const today = moment().format('YYYY-MM-DD');

class SalesInvoice extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  };
  static getFromDate() {
    const date = new Date();
    date.setDate(date.getDate() - 7);
    return date;
  }
  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.fiveLineButton,

      showFinalized: null,
      checkAuthorizeOpen: false,
      
      salesInvoices: {
        rows: [],
        selectedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },

      salesInvoiceDetail: {
        rows: [],
        selectedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      total: 0,

      suggestValue: '',
      productSearchType: 'ProductNum',
      days: '-1',
      filteredByItem: false,
      filterProductID: '',
      rowsCount: 0,
      PdfFrameLoaded: true,
      PdfFrameLoadedReturns: true,

      fromDate: SalesInvoice.getFromDate(),
      toDate: new Date(),
      typeRadios: 'all',
      statusRadios: 'all',
      PdfFrameLoadedNs: true,
      pdfFrameLoadedReturnsNs: true,

      paymentMethodModalVisibility: false,
      orderType: null,
    };

    this.handleResize = this.handleResize.bind(this);
    this.printForm = this.printForm.bind(this);
    this.fetchSalesInvoicesByDetails = this.fetchSalesInvoicesByDetails.bind(this);
    this.setFromDate = this.setFromDate.bind(this);
    this.setToDate = this.setToDate.bind(this);
    this.handleTypeFilterChange = this.handleTypeFilterChange.bind(this);
    this.handleStatusFilterChange = this.handleStatusFilterChange.bind(this);
  }

  componentWillMount() {
    if (this.context.router.routes[1].path === 'salesInvoice') {
      this.props.setField('Days', '7');
    } else {
      this.props.setField('Days', '-1');
    }
    this.props.setField('StatusFilter', 'all');
    this.props.setField('OrderFilter', 'all');
    this.props.fetchSalesInvoices('all/', today, today, null, '7');
    if (this.context.router.routes[1].path === 'salesInvoice') {
      this.setState({ days : '7', toDate: undefined, fromDate: undefined });
    }
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    let test = localStorage.getItem('userPermissions');
    window.addEventListener('resize', this.handleResize);
    this.props.fetchBaseUsers();
    if (this.context.router.routes[1].path === 'salesInvoice') {
      this.props.setField('Days', '7');
    } else {
      this.props.setField('Days', '-1');
    }
    this.props.setField('StatusFilter', 'all');
    this.props.setField('OrderFilter', 'all');
    this.props.setField('Seller', null);
    this.props.fetchSalesInvoices('all/', today, today, null, '7');
  }

  // Once products are ready, reset state.
  componentWillReceiveProps(nextProps) {
    if(nextProps.passcodeVerified && !this.props.passcodeVerified) {
      this.props.setPasscodeVerificationStatus();
      this.setCurrentSalesInvoiceAndRedirect();
    }
    if (nextProps.salesInvoice && nextProps.salesInvoice !== this.props.salesInvoice) {
      const salesInvoices = { ...this.state.salesInvoices, rows: nextProps.salesInvoice.Invoices, selectedRows: [] };
      this.setState({ salesInvoices, total: isCPG ? nextProps.salesInvoice.InvoiceGrandTotal : nextProps.salesInvoice.TotalFinalPrice });
    }

    if (nextProps.salesInvoiceDetail && nextProps.salesInvoiceDetail !== this.props.salesInvoiceDetail) {
      const salesInvoiceDetail = { ...this.state.salesInvoiceDetail, rows: nextProps.salesInvoiceDetail.Sales_Invoice_Lines };
      this.setState({ salesInvoiceDetail });
    }

    if (nextProps.salesReturnDetail && nextProps.salesReturnDetail !== this.props.salesReturnDetail) {
      const salesInvoiceDetail = { ...this.state.salesInvoiceDetail, rows: nextProps.salesReturnDetail.Sales_Return_Line };
      this.setState({ salesInvoiceDetail });
    }

    if (nextProps.OrderFilter && nextProps.OrderFilter !== this.props.OrderFilter) {
      let seller = this.props.Seller;
      let status = nextProps.StatusFilter;
      if (status === 'all') {
        status = null;
      }
      if (this.props.Seller) {
        seller = this.props.Seller.value;
      }
      let fromDate = this.state.fromDate ? this.formatDate(this.state.fromDate) : today;
      let toDate = this.state.toDate ? this.formatDate(this.state.toDate) : today;
      let days = this.props.Days;

      if (days == null) {
        days = 7;
      }
      let productNum = this.props.ProductNum;
      this.props.fetchSalesInvoices(nextProps.OrderFilter + "/", fromDate, toDate, null, days, status, seller, this.state.filterProductID, null, this.state.orderType);
    }

    if (nextProps.StatusFilter && nextProps.StatusFilter !== this.props.StatusFilter) {
      let seller = this.props.Seller;
      let status = nextProps.StatusFilter;
      if (status === 'all') {
        status = null;
      }
      if (this.props.Seller) {
        seller = this.props.Seller.value;
      }
      let fromDate = this.props.FromDate ? this.formatDate(this.props.FromDate) : today;
      let toDate = this.props.ToDate ? this.formatDate(this.props.ToDate) : today;
      let days = this.props.Days;

      if (days == null) {
        days = 7;
      }
      let productNum = this.props.ProductNum;
      this.props.fetchSalesInvoices(nextProps.OrderFilter + "/", fromDate, toDate, null, days, status, seller, this.state.filterProductID, null, this.state.orderType);
    }

    if (nextProps.Days && nextProps.Days !== this.props.Days) {
      if (nextProps.Days !== '-1') {
        this.props.setField("FromDate", null);
        this.props.setField("ToDate", null);
      }
    }

    if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
      this.closeCheckAuthorize();
      this.voidSalesInvoices();
    }

    if (nextProps.salesInvoicePdf && nextProps.salesInvoicePdf !== this.props.salesInvoicePdf) {
      this.setState({ PdfFrameLoaded: false });
    }

    if (nextProps.salesInvoiceReturnPdf && nextProps.salesInvoiceReturnPdf !== this.props.salesInvoiceReturnPdf) {
      this.setState({ PdfFrameLoadedReturns: false });
    }

    if (nextProps.salesorderPdfNs && nextProps.salesorderPdfNs !== this.props.salesorderPdfNs) {
      this.setState({ PdfFrameLoadedNs: false });
    }

    if (nextProps.salesInvoiceReturnPdfNs && nextProps.salesInvoiceReturnPdfNs !== this.props.salesInvoiceReturnPdfNs) {
      this.setState({ pdfFrameLoadedReturnsNs: false });
    }
    
    if (nextProps.Seller !== this.props.Seller) {
      let seller;
      if (nextProps.Seller) {
        seller = nextProps.Seller.value;
      }
      const FromDate = (this.context.router.routes[1].path === 'salesInvoice') ? this.props.FromDate : this.state.fromDate;
      const ToDate = (this.context.router.routes[1].path === 'salesInvoice') ? this.props.ToDate : this.state.toDate;
      const OrderFilter = (this.context.router.routes[1].path === 'salesInvoice') ? this.props.OrderFilter : this.state.typeRadios;
      const StatusFilter = (this.context.router.routes[1].path === 'salesInvoice') ? this.props.StatusFilter : this.state.statusRadios;
      let days = this.props.Days;
      let status = StatusFilter;
      if (status === 'all') {
        status = null;
      }

      if (days == null) {
        days = 7;
      }
      this.props.fetchSalesInvoices(`${OrderFilter}/`, FromDate, ToDate, null, days, status, seller, this.state.filterProductID, null, this.state.orderType);
    }

    if ((typeof (this.props.FromDate) !== 'undefined') && (typeof (this.props.ToDate) !== 'undefined') && ((nextProps.FromDate !== this.props.FromDate) || (nextProps.ToDate !== this.props.ToDate))) {
      let FromDate;
      let ToDate;
      let seller = this.props.Seller;
      let status = this.props.StatusFilter;
      if (status === 'all') {
        status = null;
      }
      if (nextProps.FromDate != null) {
        FromDate = this.formatDate(nextProps.FromDate);
      }
      if (nextProps.ToDate != null) {
        ToDate = this.formatDate(nextProps.ToDate);
      }
      if (this.props.Seller) {
        seller = this.props.Seller.value;
      }
      this.props.fetchSalesInvoices(this.props.OrderFilter + "/", FromDate, ToDate, null, -1, status, seller, this.state.filterProductID, null, this.state.orderType);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.salesInvoices !== this.state.salesInvoices) {
      this.setState({ rowsCount: Data.Selectors.getRows(this.state.salesInvoices).length });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.PdfFrameLoaded !== this.state.PdfFrameLoaded && this.state.PdfFrameLoaded === false) {
      return false;
    }
    if (nextState.PdfFrameLoadedReturns !== this.state.PdfFrameLoadedReturns && this.state.PdfFrameLoadedReturns === false) {
      return false;
    }
    if (nextState.PdfFrameLoadedNs !== this.state.PdfFrameLoadedNs && this.state.PdfFrameLoadedNs === false) {
      return false;
    }
    if (nextState.pdfFrameLoadedReturnsNs !== this.state.pdfFrameLoadedReturnsNs && this.state.pdfFrameLoadedReturnsNs === false) {
      return false;
    }
    return true;
  }

  handleResize(e) {
    this.setState({tableHeight: window.innerHeight - UI_HEIGHT.fiveLineButton});
  }

  handleOptionChange = (changeEvent) => {
    this.setState({ productSearchType: changeEvent.target.value });
  }

  handleVerifyPassocdeModalClose = (confirmed) => {
    if(confirmed) {
      this.voidSalesInvoices();
    }
    this.closeVerifyPasscode();
  }

  openChangePaymentMethodModal() {
    this.setState({
      paymentMethodModalVisibility: true,
    });
  }

  closePaymentMethodModal() {
    this.setState({
      paymentMethodModalVisibility: false,
    });
  }

  handleSOPaymentMethodSaved = (so_id, method) => {
    const salesOrderRows = [...this.state.salesInvoices.rows];
    const newRows = salesOrderRows.map(row => {
      if (row.SalesOrder_id === so_id) {
        return {
          ...row,
          PaymentType: method,
        }
      }
      return row
    })
    this.setState({
      salesInvoices: {
        ...this.state.salesInvoices,
        rows: newRows,
      }
    });
    this.closePaymentMethodModal();
  }

  openCheckAuthorize = (action) => {
    if(isEcity) {
      this.openVerifyPasscode();
      return;
    }
    this.props.clearCheckPassword();
    this.setState({ checkAuthorizeOpen: true, action });
  }
  closeCheckAuthorize = () => {
    this.setState({ checkAuthorizeOpen: false });
  }
  checkAuthorize = (password) => {
    this.props.checkPassword(password);
  }
  
  openVerifyPasscode = () => {
    this.setState({
      verifyPasscodeOpen: true,
    })
  }
  closeVerifyPasscode = () => {
    this.setState({
      verifyPasscodeOpen: false,
    })
  }

  shouldVoidButtonDisable = () => {
    const { selectedRows } = this.state.salesInvoices;

    // Always disable void if selected more than 1 row
    if (selectedRows.length !== 1) {
      return true;
    }

    const status = selectedRows[0] ? selectedRows[0].SaleStatus : 'disable';
    if (status === 'disable') {
      return true;
    }
    const disabled = (
      status !== 'Released' &&
      status !== 'Open'
    );
    return disabled;
  }

  // Set product being selected to be currentProduct and navigate user to the edit page
  setCurrentSalesInvoice = (e) => {
    e.preventDefault();
    if(isRivera) {
      this.props.setConfirmPasscodeModalVisibility(true);
      return;
    }
    this.setCurrentSalesInvoiceAndRedirect();
  }

  setCurrentSalesInvoiceAndRedirect() {
    const currentSalesInvoice = this.state.salesInvoices.selectedRows[0];
    this.props.resetCurrentSalesInvoice();
    this.props.selectSalesInvoice(currentSalesInvoice);
    if (typeof currentSalesInvoice.SalesInvoice_id !== 'undefined' && currentSalesInvoice.SalesInvoice_id != null){
      this.context.router.push('/salesInvoice/'+ currentSalesInvoice.SalesInvoice_id);
    } else if (currentSalesInvoice.ReturnStatus === 'Open'){
      this.context.router.push('/customerReturn/'+currentSalesInvoice.SalesReturn_id);
    } else {
      this.context.router.push('/customerCredit/'+currentSalesInvoice.SalesReturn_id);
    }
  }

  clickNew(e) {
    e.preventDefault();
    this.props.resetCurrentSalesInvoice();
    this.context.router.push('/salesInvoice/new')
  }

  formatDate(date) {
    let formattedDate = date.getFullYear() + '-';

    formattedDate += date.getMonth()+1 + '-';
    if (date.getDate() < 10) {
      formattedDate += '0' + date.getDate();
    } else {
      formattedDate += date.getDate();
    }
    return formattedDate;
  }

  handleTypeFilterChange(type) {
    const seller = (this.props.Seller) ? this.props.Seller.value : undefined;
    const status = (this.state.statusRadios === 'all') ? null : this.state.statusRadios;
    this.setState({ typeRadios: type }, () => { this.props.fetchSalesInvoices(`${this.state.typeRadios}/`, this.state.fromDate, this.state.toDate, null, -1, status, seller, this.state.filterProductID, null, this.state.orderType); });
  }

  handleStatusFilterChange(status) {
    const seller = (this.props.Seller) ? this.props.Seller.value : undefined;
    if (status === 'all') {
      // status is set to null because api requires no parameter to filter by 'all'
      this.setState({ statusRadios: status }, () => { this.props.fetchSalesInvoices(`${this.state.typeRadios}/`, this.state.fromDate, this.state.toDate, null, -1, null, seller, this.state.filterProductID, null, this.state.orderType); });
    } else {
      this.setState({ statusRadios: status }, () => { this.props.fetchSalesInvoices(`${this.state.typeRadios}/`, this.state.fromDate, this.state.toDate, null, -1, this.state.statusRadios, seller, this.state.filterProductID, null, this.state.orderType); });
    }
  }

  handleOrderTypeChange = (orderType) => {
    const seller = (this.props.Seller) ? this.props.Seller.value : undefined;
    this.setState({
      orderType,
    })
    this.props.fetchSalesInvoices(`${this.state.typeRadios}/`, this.state.fromDate, this.state.toDate, null, -1, null, seller, this.state.filterProductID, null, orderType)
  }

  setToDate(e) {
    if (e < this.state.fromDate) {
      return;
    }
    this.setState({ toDate: e });
  }

  setFromDate(e) {
    if (e > this.state.toDate) {
      return;
    }
    this.setState({ fromDate: e });
  }

  fetchSalesInvoicesByDatePickerSearch = () => {
    const seller = (this.props.Seller) ? this.props.Seller.value : undefined;
    const status = (this.state.statusRadios === 'all') ? null : this.state.statusRadios;
    this.props.fetchSalesInvoices(`${this.props.OrderFilter}/`, this.state.fromDate, this.state.toDate, null, -1, status, seller, this.state.filterProductID, null, this.state.orderType);
  }


  setToRangeSearch = () => {
    this.setState({ days: '-1' });
  }

  renderDatePickers() {
    return (
      <Col xs={12}>
        <div className="date-pickers">
          <div className="fromDate-picker">
            <GenericDatePicker setDate={this.setFromDate} selectedDate={this.state.fromDate} />
          </div>
          <div className="toDate-picker">
            <GenericDatePicker setDate={this.setToDate} selectedDate={this.state.toDate} />
          </div>
          <Button
            className="search-button"
            bsStyle="primary"
            onClick={() => { this.fetchSalesInvoicesByDatePickerSearch(); }}
          >
            <em className="fa fa-search" />
          </Button>
        </div>
      </Col>
    );
  }

  fetchSalesInvoicesByDetails = (days) => {
    if (this.state.filteredByItem) {
      this.setState({ days }, () => {
        this.fetchSalesInvoicesByProduct(this.state.filterProductID);
      });
      return;
    }
    let dateRange = -1;
    let FromDate = '2016-01-01';
    let ToDate = today;
    let status = this.props.StatusFilter;
    let seller;
    if (this.props.Seller) {
      seller = this.props.Seller.value;
    }
    if (status === 'all') {
      status = null;
    }
    if (this.state.fromDate != null) { FromDate = this.formatDate(this.state.fromDate); }

    if (this.state.toDate != null) { ToDate = this.formatDate(this.state.toDate); }

    if (days != null) { dateRange = days; }

    if (days === '-1' || days === -1) {
      this.setState({ days }, () => {
        this.props.fetchSalesInvoices(this.props.OrderFilter + "/", FromDate, ToDate, null, dateRange, status, seller, null, null, this.state.orderType);
      });
    } else {
      this.setState({ days, fromDate: undefined, toDate: undefined }, () => { this.props.fetchSalesInvoices(this.props.OrderFilter + "/", FromDate, ToDate, null, dateRange, status, seller, null, null, this.state.orderType); });
    }
  }

  fetchSalesInvoicesByProduct = (productID) => {
    let dateRange = -1;
    let FromDate = '1900-01-01';
    let ToDate = today;
    let route = this.context.router.routes[1].path;
    let status = this.props.StatusFilter;
    const productNum = productID;
    let seller;
    if (this.props.Seller) {
      seller = this.props.Seller.value;
    }
    if (this.state.fromDate != null) {
      FromDate = this.formatDate(this.state.fromDate);
    }
    if (this.state.toDate != null) {
      ToDate = this.formatDate(this.state.toDate);
    }
    if (this.state.days != null) {
      dateRange = this.state.days;
    }
    if (this.props.Seller) {
      seller = this.props.Seller.value;
    }
    if (status === 'all') {
      status = null;
    }
    this.setState({ filteredByItem: true, selectedRows: [{}], filterProductID: productID });
    this.props.fetchSalesInvoices(this.props.OrderFilter + "/", FromDate, ToDate, null, dateRange, status, seller, productID, null, this.state.orderType);
  }

  renderGenericTypeRadios() {
    return (
      <div>
        {
        genericRadioFilter({
          content: [
            {
              option: 'all',
              id: 'all-radio-filter',
              name: 'typeFilterRadios',
              labelName: 'all',
            },
            {
              option: 'invoices',
              id: 'invoices-radio-filter',
              name: 'typeFilterRadios',
              labelName: 'sales',
            },
            {
              option: 'returns',
              id: 'returns-radio-filter',
              name: 'typeFilterRadios',
              labelName: 'returns',
            },
          ],
          value: this.state.typeRadios,
          handleOnClick: this.handleTypeFilterChange,
          type: 'buttons',
        })
        }
      </div>
    );
  }

  renderGenericStatusRadios() {
    return (
      <div>
        {
          genericRadioFilter({
            content: [
              {
                option: 'all',
                id: 'all-status-radio-filter',
                name: 'statusFilterRadios',
                labelName: 'all',
              },
              {
                option: 'Released',
                id: 'released-radio-filter',
                name: 'statusFilterRadios',
                labelName: 'released',
              },
              {
                option: 'Finalized',
                id: 'finalized-radio-filter',
                name: 'statusFilterRadios',
                labelName: 'finalized',
              },
              {
                option: 'Void',
                id: 'void-radio-filter',
                name: 'statusFilterRadios',
                labelName: 'void',
              },
            ],
            value: this.state.statusRadios,
            handleOnClick: this.handleStatusFilterChange,
            type: 'buttons',
          })
        }
        </div>);
  }

  renderGenericOrderTypeRadios = () => {
    const options = {
      content: [
        {
          option: null,
          id: 'ordertypeall-status-radio-filter',
          name: 'ordertypeFilterRadios',
          labelName: 'normal',
        },
        {
          option: 'IsRelocation',
          id: 'relocate-radio-filter',
          name: 'ordertypeFilterRadios',
          labelName: 'relocate',
        },
        {
          option: 'IsTransfer',
          id: 'transfer-radio-filter',
          name: 'ordertypeFilterRadios',
          labelName: 'transfer',
        },
      ],
      value: this.state.orderType,
      handleOnClick: this.handleOrderTypeChange,
      type: 'buttons',
    };
    return (
      <div>
        {
          genericRadioFilter(options)
        }
      </div>
    );
  }

  // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
  renderTable() {
    if (this.props.isLoading && !this.props.error) return <Spinner />
    else if (this.props.error) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">
            {JSON.stringify(this.props.error)}
          </div>
        </ContentWrapper>
      );
    }

    // Parameters of the react-data-grid
    let tableHeight = (window.innerHeight < 900) ? 270 : 270;
    if (this.context.router.routes[1].path !== 'salesInvoice') { tableHeight = 500; }

    const getRows = () => {
      // Doing this because i need unique id's for each row and the invoices i get from
      // the backend dont all have a consistent field i can use. I used this new id for rowKey
      const rows = Data.Selectors.getRows(this.state.salesInvoices);
      const rowsWithId = rows.map((row, i) => ({
        ...row,
        dataGridId: i,
      }));
      return rowsWithId;
    };

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    }

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.salesInvoices, { sortColumn, sortDirection });
      this.setState({ salesInvoices: state });
    };

    const handleFilterChange = (filter) => {
      let newFilters = Object.assign({}, this.state.salesInvoices.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const salesInvoices = { ...this.state.salesInvoices, filters: newFilters };
      this.setState({ salesInvoices });
    };

    // Handle the row select function
    const onRowSelect = (rows) => {
      const salesInvoices = { ...this.state.salesInvoices, selectedRows: rows };
      this.setState({ salesInvoices });
    };

    const onRowClick = (rowIdx, row) => {
      if (row) {
        if (row.SalesInvoice_id !== null) { this.props.fetchSalesInvoiceDetail(row.SalesInvoice_id); }
        else { this.props.fetchSalesReturnDetail(row.SalesReturn_id); }
      }
    //   const invoiceRows = [...this.state.salesInvoices.rows];
    //   invoiceRows.map((r) => {
    //     r.isSelected = false;
    //   });
    //   const selectedRows = [invoiceRows[rowIdx]];
    //   invoiceRows[rowIdx].isSelected = true;

    //   const salesInvoices = { ...this.state.salesInvoices, rows: invoiceRows, selectedRows };
    //   this.setState({ salesInvoices });
    // };


    // const onRowsSelected = (rows) => {
    //   const newRows = getRows();
    //   const selectedRows = [...this.state.salesInvoices.selectedRows];
    //   rows.map((r) => {
    //     newRows[r.rowIdx].isSelected = true;
    //     selectedRows.push(r.row);
    //   });
    //   const salesInvoices = { ...this.state.salesInvoices, rows: newRows, selectedRows };
    //   this.setState({ salesInvoices });
    // };

    // const onRowsDeselected = (rows) => {
    //   const newRows = [...this.state.salesInvoices.rows];
    //   const selectedRows = [...this.state.salesInvoices.selectedRows];
    //   rows.map((r) => {
    //     newRows[r.rowIdx].isSelected = false;
    //     let rowIndex;
    //     selectedRows.forEach((row, idx) => {
    //       if (row.InvoiceNum === r.row.InvoiceNum) {
    //         rowIndex = idx;
    //       }
    //     });
    //     selectedRows.splice(rowIndex, 1);
    //   });
    //   const salesInvoices = { ...this.state.salesInvoices, rows: newRows, selectedRows };
    //   this.setState({ salesInvoices });
    };


    const onCellSelected = (coordinates) => {
      const newRows = getRows();
      /* Multi row select on cell selected
                let selectedRows = [...this.state.salesOrders.selectedRows];
                newRows[coordinates.rowIdx].isSelected = true;
                let id = newRows[coordinates.rowIdx].SalesOrder_id;
                if (selectedRows.indexOf(id) == -1) {
                    selectedRows.push(id);
                }
              */
      /* Single row select on cell selected */
      const selectedRows = [...this.state.salesInvoices.selectedRows];
      newRows[coordinates.rowIdx].isSelected = true;
      const salesInvoices = { ...this.state.salesInvoices, rows: newRows, selectedRows };
      this.setState({ salesInvoices });
    };

    // Custom Formatter component
    const DateFormatter = React.createClass({
      render() {
        if (this.props.value) {
          const date = new Date(this.props.value)
          return <span>{date.toString().slice(4, 15)}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });

    // Column difinition
    let columns = [];
    if (this.context.router.routes[1].path !== 'salesInvoice') {
      columns = [
        {
          key: 'InvoiceNum',
          name: <Translate value="invoice_no" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'SONum',
          name: <Translate value="related_no" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        },
        {
          key: 'CustomerNum',
          name: <Translate value="customer_num" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'Customer_Name',
          name: <Translate value="customer_name" />,
          resizable: true,
          sortable: true,
          width: 250,
          filterable: true,
        },
        {
          key: 'Customer_Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 110,
        },
        {
          key: 'PostingDate',
          name: <Translate value="invoice_date" />,
          resizable: true,
          sortable: true,
          width: 125,
          filterable: true,
          formatter: DateFormatter,
        },
        {
          key: 'FinalPrice',
          name: <Translate value="final_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 75,
          filterable: true,
          formatter: CashFormatter,
        },
        {
          key: 'City',
          name: <Translate value="city" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        },
        {
          key: 'Sales_Username',
          name: <Translate value="sales" />,
          resizable: true,
          sortable: true,
          width: 75,
          filterable: true,
        },
        {
          key: 'SaleStatus',
          name: <Translate value="status" />,
          resizable: true,
          sortable: true,
          width: 65,
          filterable: true,
        },
        {
          key: 'PaymentType',
          name: <Translate value="payment" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'SalesMargin',
          name: <Translate value="sales_margin_percentsign" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          formatter: PercentFormatter,
        },
        {
          key: 'PaymentStatusRecord',
          name: <Translate value="pmt_status" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
      ];
    } else {
      columns = [
        {
          key: 'InvoiceNum',
          name: <Translate value="invoice_no" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'SONum',
          name: <Translate value="related_no" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        },
        {
          key: 'CustomerNum',
          name: <Translate value="customer_num" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'Customer_Name',
          name: <Translate value="customer_name" />,
          resizable: true,
          sortable: true,
          width: 158,
          filterable: true,
        },
        {
          key: 'Customer_Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 110,
        },
        {
          key: 'PostingDate',
          name: <Translate value="invoice_date" />,
          resizable: true,
          sortable: true,
          width: 110,
          filterable: true,
          formatter: DateFormatter,
        },
        {
          key: isTN ? 'InvoiceShipDate' : 'DispatchDate',
          name: <Translate value="shipped" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
          formatter: DateFormatter,
        },
        {
          key: 'BillDueDate',
          name: <Translate value="bill_date" />,
          resizable: true,
          sortable: true,
          width: 110,
          filterable: true,
          formatter: DateFormatter,
        },
        {
          key: 'FinalPrice',
          name: <Translate value="final_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 75,
          filterable: true,
          formatter: CashFormatter,
        },
        {
          key: 'City',
          name: <Translate value="city" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        },
        {
          key: 'Sales_Username',
          name: <Translate value="sales" />,
          resizable: true,
          sortable: true,
          width: 75,
          filterable: true,
        },
        {
          key: 'SaleStatus',
          name: <Translate value="status" />,
          resizable: true,
          sortable: true,
          width: 65,
          filterable: true,
        },
        {
          key: 'PaymentType',
          name: <Translate value="payment" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'SalesMargin',
          name: <Translate value="sales_margin_percentsign" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          formatter: PercentFormatter,
        },
      ];
    }

    if (this.context.router.routes[1].path === 'salesInvoice') {
      const indexBillDueDate = _.findIndex(columns, { key: 'BillDueDate' });
      const indexDispatchDate = _.findIndex(columns, { key: 'DispatchDate' });
      const indexPostingDate = _.findIndex(columns, { key: 'PostingDate' });
      const billColumn = {
        key: 'BillDueDateDisplay',
        name: <Translate value="bill_date" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
      };
      const dispatchColumn = {
        key: 'DispatchDateDisplay',
        name: <Translate value="dispatch" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      };
      const postingColumn = {
        key: 'PostingDateDisplay',
        name: <Translate value="invoice_date" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
      };
      columns.splice(indexBillDueDate, 1, billColumn);
      columns.splice(indexDispatchDate, 1, dispatchColumn);
      columns.splice(indexPostingDate, 1, postingColumn);

      if (this.state.salesInvoices.rows.length > 0) {
        this.state.salesInvoices.rows.map((row) => {
          row.BillDueDateDisplay = moment(row.BillDueDate).format('MM-DD-YY HH:mm');
          row.DispatchDateDisplay = moment(row.DispatchDate).format('MM-DD-YY HH:mm');
          row.PostingDateDisplay = moment(row.PostingDate).format('MM-DD-YY HH:mm');
        });
      }

      if (isEcity && checkPermission('show_real_sales_margin')) {
        const indexSalesMargin = _.findIndex(columns, { key: 'SalesMargin' });
        const salesMarginColumn = {
          key: 'RealSalesMargin',
          name: <Translate value="sales_margin_master_percentsign" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          formatter: PercentFormatter,
        };
        columns.splice(indexSalesMargin, 1, salesMarginColumn);
      }
    }

    return (
      // React Table Sales Invoice History
      <Row>
        <Col xs={12}>
          <div id="SalesInvoice-dataGrid1">
            <ReactDataGrid
              rowRenderer={
                <CtRowRenderer 
                  permissionCheck={checkPermission('show_real_sales_margin')}
                  isEcity={isEcity}
                />
              }
              rowKey="dataGridId"
              onGridSort={handleGridSort}
              toolbar={<Toolbar enableFilter={true} />}
              onAddFilter={handleFilterChange}
              columns={columns}
              headerRowHeight={45}
              rowHeight={25}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              minHeight={tableHeight}
              enableRowSelect="multi"
              onRowSelect={onRowSelect}
              onRowClick={onRowClick}
              // rowSelection={{
              //   showCheckbox: true,
              //   enableShiftSelect: true,
              //   onRowsSelected,
              //   onRowsDeselected,
              //   selectBy: {
              //     isSelectedKey: 'isSelected',
              //   },
              // }}
              // onCellSelected={onCellSelected}
            />
          </div>
        </Col>
      </Row>
    );
  }

  // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
  renderSalesInvoiceDetailTable() {
    if (this.props.detailIsLoading && !this.props.detailError) { return <Spinner />; }
    else if (this.props.detailError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">
            {JSON.stringify(this.props.detailError)}
          </div>
        </ContentWrapper>
      );
    }

    // Parameters of the react-data-grid
    const tableHeight = (window.innerHeight < 900) ? 185 : 185;

    const getRows = () => Data.Selectors.getRows(this.state.salesInvoiceDetail);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.salesInvoiceDetail, { sortColumn, sortDirection });
      this.setState({ salesInvoiceDetail: state });
    };

    // Handle the row select function
    const onRowSelect = (rows) => {
      this.setState({ selectedRows: rows });
    };

    // Column difinition
    const columns = [
      {
        key: 'ProductNum',
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: 'RefNum',
        name: isTN ? <Translate value="sku" /> : <Translate value={isOLG ? "item_no" : "ref_num"} />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: 'Name',
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 200,
      },
      {
        key: 'Description',
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 200,
      },
      {
        key: 'Quantity',
        name: <Translate value="order_qty" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: 'LoadedQuantity',
        name: <Translate value="shipped_qty" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: 'PackageType',
        name: <Translate value="pkg_type" />,
        resizable: true,
        sortable: true,
        width: 80,
      },
      {
        key: 'TotalNetWeight',
        name: <Translate value="total_wt" />,
        resizable: true,
        sortable: true,
        width: 100,
        height: 50,
      },
      {
        key: 'UnitPrice',
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 70,
      },
    ];

    if(isHMM) {
      let temp1, temp2;
      temp1 = {
        key: 'TotalPrice',
        name: <Translate value="total_price" />,
        resizable: true,
        sortable: true,
        width: 70,
      }
      temp2 = {
        key: 'PackageSize',
        name: <Translate value="package_size" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      columns.push(temp1);
      columns.splice(4, 0, temp2);
    }
    return (
      // Detailed Information Table
      <Row>
        <Col xs={12}>
          <div id="SalesInvoice-dataGrid2">
            <ReactDataGrid
              columns={columns}
              headerRowHeight={45}
              minHeight={tableHeight}
              onGridSort={handleGridSort}
              onRowSelect={onRowSelect}
              onRowUpdated={this.handleRowUpdated}
              rowGetter={rowGetter}
              rowHeight={25}
              rowKey="SalesInvoice_id"
              rowsCount={getSize()}
            />
          </div>
        </Col>
      </Row>
    );
  }

  renderAutoSuggest() {
    if (!this.state.filteredByItem) {
      return (
        <div className="control-dropdown">
          <GenericProductSuggest
            value={this.state.suggestValue}
            onChange={(e, { newValue }) => { this.setState({ suggestValue: newValue }); }}
            SearchType={this.state.productSearchType}
            fetchOrdersByProduct={this.fetchSalesInvoicesByProduct}
          />
        </div>
      );
    }
    return (
      <div id="suggestion-box">
        {this.state.suggestValue}
        <em className="fa fa-times pull-right" onClick={() => { this.setState({ filteredByItem: false, suggestValue: '', filterProductID: null }, () => { this.fetchSalesInvoicesByDetails(this.state.days); }); }} />
      </div>
    );
  }

  setButtonStatus(value) {
    this.setState({ showFinalized: value });
  }

  /*
   * sends api request to finalize selected Invoices. if successful, refreshes the invoice data grid.
   * params: none
   * returns: none
   */
  finalizeSalesOrders() {
    // FromDate, ToDate, OrderFilter, and StatusFilter are needed for the two different Sales Invoices pages
    const FromDate = (this.context.router.routes[1].path === 'salesInvoice') ? this.state.fromDate : this.state.fromDate;
    const ToDate = (this.context.router.routes[1].path === 'salesInvoice') ? this.state.toDate : this.state.toDate;
    const OrderFilter = (this.context.router.routes[1].path === 'salesInvoice') ? this.props.OrderFilter : this.state.typeRadios;
    let StatusFilter = (this.context.router.routes[1].path === 'salesInvoice') ? this.props.StatusFilter : this.state.statusRadios;
    if (StatusFilter === 'all') {
      StatusFilter = null;
    }
    const seller = (this.props.Seller) ? this.props.Seller.value : undefined;

    // Get the ids of selected invoices
    const salesInvoiceIds = [];
    this.state.salesInvoices.selectedRows.forEach((salesInvoice) => {
      salesInvoiceIds.push(salesInvoice.SalesInvoice_id);
    });

    // Make the api calls
    this.props.finalizeInvoice(salesInvoiceIds)
      .then(() => {
        this.props.fetchSalesInvoices(`${OrderFilter}/`, FromDate, ToDate, null, this.props.Days, StatusFilter, seller, this.state.filterProductID, null, this.state.orderType);
      });
  }

  deliverSalesOrders() {
    // FromDate, ToDate, OrderFilter, and StatusFilter are needed for the two different Sales Invoices pages
    const FromDate = (this.context.router.routes[1].path === 'salesInvoice') ? this.state.fromDate : this.state.fromDate;
    const ToDate = (this.context.router.routes[1].path === 'salesInvoice') ? this.state.toDate : this.state.toDate;
    const OrderFilter = (this.context.router.routes[1].path === 'salesInvoice') ? this.props.OrderFilter : this.state.typeRadios;
    let StatusFilter = (this.context.router.routes[1].path === 'salesInvoice') ? this.props.StatusFilter : this.state.statusRadios;
    if (StatusFilter === 'all') {
      StatusFilter = null;
    }
    const seller = (this.props.Seller) ? this.props.Seller.value : undefined;
    const salesInvoiceIds = [];
    this.state.salesInvoices.selectedRows.forEach((salesInvoice) => {
      salesInvoiceIds.push(salesInvoice.SalesInvoice_id);
    });

    this.props.deliverInvoice(salesInvoiceIds)
      .then(() => {
        this.props.fetchSalesInvoices(`${OrderFilter}/`, FromDate, ToDate, null, this.props.Days, StatusFilter, seller, this.state.filterProductID, this.state.orderType);
      });
  }

  voidSalesInvoices = () => {
    // FromDate, ToDate, OrderFilter, and StatusFilter are needed for the two different Sales Invoices pages
    const FromDate = (this.context.router.routes[1].path === 'salesInvoice') ? this.state.fromDate : this.state.fromDate;
    const ToDate = (this.context.router.routes[1].path === 'salesInvoice') ? this.state.toDate : this.state.toDate;
    const OrderFilter = (this.context.router.routes[1].path === 'salesInvoice') ? this.props.OrderFilter : this.state.typeRadios;
    let StatusFilter = (this.context.router.routes[1].path === 'salesInvoice') ? this.props.StatusFilter : this.state.statusRadios;
    if (StatusFilter === 'all') {
      StatusFilter = null;
    }
    const seller = (this.props.Seller) ? this.props.Seller.value : undefined;
    const pk = this.state.salesInvoices.selectedRows && this.state.salesInvoices.selectedRows.length === 1 && this.state.salesInvoices.selectedRows[0].SalesInvoice_id;
    const returnpk = this.state.salesInvoices.selectedRows && this.state.salesInvoices.selectedRows.length === 1 && this.state.salesInvoices.selectedRows[0].SalesReturn_id;
    if (pk) {
      this.state.salesInvoices.selectedRows.map((row) => {
        this.props.voidInvoice(row.SalesInvoice_id)
          .then(() => {
            this.props.fetchSalesInvoices(`${OrderFilter}/`, FromDate, ToDate, null, this.props.Days, StatusFilter, seller, this.state.filterProductID, null, this.state.orderType);
          })
      });
    } else if (returnpk) {
      this.state.salesInvoices.selectedRows.map((row) => {
        this.props.voidReturn(row.SalesReturn_id)
          .then(() => {
            this.props.fetchSalesInvoices(`${OrderFilter}/`, FromDate, ToDate, null, this.props.Days, StatusFilter, this.props.Seller, this.state.filterProductID, null, this.state.orderType);
          })
      });
    }
  }

  printForm() {
    this.props.printInvoice(this.state.salesInvoices.selectedRows[0].SalesInvoice_id);
  }

  salesInvoiceIFrameIsLoaded = () => {
    this.setState({ PdfFrameLoaded: true });
  }

  salesReturnIFrameIsLoaded = () => {
    this.setState({ PdfFrameLoadedReturns: true });
  }

  renderPrintSalesInvoiceIframe() {
    const pk = this.state.salesInvoices.selectedRows && this.state.salesInvoices.selectedRows.length === 1 && this.state.salesInvoices.selectedRows[0].SalesInvoice_id;
    const returnpk = this.state.salesInvoices.selectedRows && this.state.salesInvoices.selectedRows.length === 1 && this.state.salesInvoices.selectedRows[0].SalesReturn_id;
    const { PdfFrameLoaded, PdfFrameLoadedReturns } = this.state;
    const { salesInvoicePdf, salesInvoiceReturnPdf } = this.props;
    let iframeProps = {};
    if (pk) {
      iframeProps = {
        id: 'salesInvoicePDF',
        loaded: PdfFrameLoaded,
        name: 'Pdf',
        onLoad: this.salesInvoiceIFrameIsLoaded,
        pdf: salesInvoicePdf,
        title: <Translate value="print_sales_invoice" />,
      };
    } else if (returnpk) {
      iframeProps = {
        id: 'salesInvoiceReturnPDF',
        loaded: PdfFrameLoadedReturns,
        name: 'Pdf',
        onLoad: this.salesReturnIFrameIsLoaded,
        pdf: salesInvoiceReturnPdf,
        title: <Translate value="print_sales_return" />,
      };
    }
    return (
      <PrintIframe
        {...iframeProps}
      />
    );
  }

  salesInvoiceIFrameIsLoaded = () => {
    if (!this.state.PdfFrameLoaded) {
      const pdfFrame = window.frames.salesInvoicePdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ PdfFrameLoaded: true });
    }
  }

  renderSalesInvoiceIFrame() {
    if (this.props.salesInvoicePdf) {
      const file = window.URL.createObjectURL(this.props.salesInvoicePdf);
      return (
        <iframe style={{ display: 'none' }} onLoad={this.salesInvoiceIFrameIsLoaded} id="salesInvoicePdf" name="salesInvoicePdf" src={file} />
      );
    }
  }

  salesInvoiceIFrameIsLoadedNs = () => {
    if (!this.state.PdfFrameLoadedNs) {
      const pdfFrame = window.frames.salesorderPdfNs;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ PdfFrameLoadedNs: true });
    }
  }
  renderSalesInvoiceIFrameIsLoadedNs = () => {
    if (this.props.salesorderPdfNs) {
      const file = window.URL.createObjectURL(this.props.salesorderPdfNs);
      return (
        <iframe style={{ display: 'none' }} onLoad={this.salesInvoiceIFrameIsLoadedNs} id="salesorderPdfNs" name="salesorderPdfNs" src={file} />
      );
    }
  }

  salesReturnIFrameIsLoadedNs = () => {
    if (!this.state.pdfFrameLoadedReturnsNs) {
      const pdfFrame = window.frames.salesInvoiceReturnPdfNs;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ pdfFrameLoadedReturnsNs: true });
    }
  }
  renderSalesInvoiceIFrameReturnNs = () => {
    if (this.props.salesInvoiceReturnPdfNs) {
      const file = window.URL.createObjectURL(this.props.salesInvoiceReturnPdfNs);
      return (
        <iframe style={{ display: 'none' }} onLoad={this.salesReturnIFrameIsLoadedNs} id="salesInvoiceReturnPdfNs" name="salesInvoiceReturnPdfNs" src={file} />
      );
    }
  }

  salesReturnIFrameIsLoaded = () => {
    if (!this.state.PdfFrameLoadedReturns) {
      const pdfFrame = window.frames.salesInvoiceReturnPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ PdfFrameLoadedReturns: true });
    }
  }
  renderSalesReturnIFrame() {
    if (this.props.salesInvoiceReturnPdf) {
      const file = window.URL.createObjectURL(this.props.salesInvoiceReturnPdf);
      return (
        <iframe style={{ display: 'none' }} onLoad={this.salesReturnIFrameIsLoaded} id="salesInvoiceReturnPdf" name="salesInvoiceReturnPdf" src={file} />
      );
    }
  }

  // renderPrintSalesReturnIframe() {
  //   const { PdfFrameLoadedReturns } = this.state;
  //   const { salesInvoiceReturnPdf } = this.props;
  //   return (
  //     <PrintIframe
  //       id="salesInvoiceReturnPDF"
  //       loaded={PdfFrameLoadedReturns}
  //       name="Pdf"
  //       onLoad={this.salesReturnIFrameIsLoaded}
  //       pdf={salesInvoiceReturnPdf}
  //       title={<Translate value="print_sales_invoice" />}
  //     />
  //   );
  // }

  /* renderIFrame() {
    const selectedRow = this.state.salesInvoices.selectedRows[0];
    if (selectedRow) {
      if (this.props.salesInvoicePdf && !selectedRow.SalesReturn_id) {
        var file = window.URL.createObjectURL(this.props.salesInvoicePdf);
        return (
            <iframe style={{ display: 'none'}} onLoad={this.IFrameIsLoaded} id="Pdf" name="Pdf" src={file} />
        );
      }
      if (this.props.salesInvoiceReturnPdf && !selectedRow.SalesInvoice_id) {
        var file = window.URL.createObjectURL(this.props.salesInvoiceReturnPdf);
        return (
            <iframe style={{ display: 'none'}} onLoad={this.IFrameIsLoaded} id="Pdf" name="Pdf" src={file} />
        );
      }
    }
  } */

  renderPaymentMethodChangeButton() {
    const { selectedRows } = this.state.salesInvoices;
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={selectedRows.length !== 1}
        onClick={() => {
        this.openChangePaymentMethodModal();
      }}
      >
        <Translate value="change_payment_method" />
      </Button>
    );
  }

  handlePrintOnClick = () => {
    const pk = this.state.salesInvoices.selectedRows && this.state.salesInvoices.selectedRows.length === 1 && this.state.salesInvoices.selectedRows[0].SalesInvoice_id;
    const returnpk = this.state.salesInvoices.selectedRows && this.state.salesInvoices.selectedRows.length === 1 && this.state.salesInvoices.selectedRows[0].SalesReturn_id;
    if (pk) {
      this.props.printSalesInvoice(pk);
    } else if (returnpk) {
      this.props.printSalesInvoiceReturn(returnpk);
    }
  }

  handleNSPrintonClick = () => {
    const pk = this.state.salesInvoices.selectedRows && this.state.salesInvoices.selectedRows.length === 1 && this.state.salesInvoices.selectedRows[0].SalesInvoice_id;
    const returnpk = this.state.salesInvoices.selectedRows && this.state.salesInvoices.selectedRows.length === 1 && this.state.salesInvoices.selectedRows[0].SalesReturn_id;
    if (pk) {
      this.props.printSalesInvoiceNoSubtotals(pk);
    } else if (returnpk) {
      this.props.printSalesInvoiceReturnsNoSubtotals(returnpk);
    }
  }
  
  handlePrintDisabled = () => {
    const pk = this.state.salesInvoices.selectedRows && this.state.salesInvoices.selectedRows.length === 1 && this.state.salesInvoices.selectedRows[0].SalesInvoice_id;
    const returnpk = this.state.salesInvoices.selectedRows && this.state.salesInvoices.selectedRows.length === 1 && this.state.salesInvoices.selectedRows[0].SalesReturn_id;
    if (this.props.requestingSalesInvoicePdf || this.props.requestingSalesInvoiceReturnPdf) {
      return true;
    }
    if (!pk && !returnpk) {
      return true;
    }
    return false;
  }

  renderPrint() {
    return (
      <Button
        bsStyle="primary"
        className="btn btn-primary marginLeftStyle"
        disabled={this.handlePrintDisabled() || !checkPermission('print_sales_invoice')}
        type="button"
        onClick={this.handlePrintOnClick}
      >
        <em className={this.renderPrintIcon()} /><Translate value="print" />
      </Button>
    );
  }

  renderPrintNs() {
    return (
      <Button
        bsStyle="primary"
        className="btn btn-primary marginLeftStyle"
        disabled={this.handlePrintDisabled() || !checkPermission('print_sales_invoice')}
        type="button"
        onClick={this.handleNSPrintonClick}
      >
        <em className={this.renderPrintIcon()} /><Translate value="print_ns" />
      </Button>
    );
  }

  renderPrintIcon() {
    if (this.props.printSalesInvoiceIsLoading && !this.props.salesInvoiceReturnPdfError && !this.props.salesInvoicePdfError) {
      return 'fa fa-spinner fa-spin';
    }
    return 'fa fa-print';
  }

  renderUsers() {
    if (this.props.usersIsLoading) return <Spinner />; // If group is loading, show a spinner.

    let Users = this.getUsers();
    return (
      <div className="control-dropdown">
        <Field name="Seller" component={Selection} options={Users} />
      </div>
    );
  }

  getUsers() {
    let Users = [];
    this.props.users.map((user) => {
      Users.push({ value: user.user_id, label: user.username });
    });
    return Users;
  }

  /*
  * checks if finalize button should be greyed out or not.
  * params: none
  * returns: true if button should be disabled. false otherwise.
  */
  shouldDisableFinalizeButton() {
    // Quick initial checks
    if (!this.state.salesInvoices.selectedRows ||
      this.state.salesInvoices.selectedRows.length <= 0 ||
      this.props.finalizingSalesInvoice ||
      this.props.deliveringSalesInvoice ||
      this.props.isLoading ||
      !checkPermission('edit_finalize_sales_invoice')) {
      return true;
    }

    // Make sure every sales invoice selected is released and has an id
    const selectedSalesInvoices = this.state.salesInvoices.selectedRows;
    for (let i = 0; i < selectedSalesInvoices.length; i += 1) {
      if ((selectedSalesInvoices[i].SaleStatus !== 'Released' && selectedSalesInvoices[i].SaleStatus !== 'Delivered') ||
        !selectedSalesInvoices[i].SalesInvoice_id) {
        return true;
      }
    }

    // Passes all checks, so allow user to finalize
    return false;
  }

  renderFinalizeButton() {
    const { selectedRows } = this.state.salesInvoices;
    // Finds the index of a selected row that is not a Mobile SI. Note: Sales Returns do not have IsMobile field
    const notAllMobile = (selectedRows.length > 0) ? _.findIndex(selectedRows, row => row.IsMobile !== true) : 1;
    const isDelivered = (selectedRows.length > 0) ? _.findIndex(selectedRows, row => row.SaleStatus === 'Delivered') : 1;
    if (notAllMobile > -1 || isDelivered > -1) {
      return (
        <Button
          bsStyle="success"
          type="submit"
          onClick={() => { this.finalizeSalesOrders(); }}
          disabled={this.shouldDisableFinalizeButton()}
        >
          <em className="fa fa-check" /><Translate value="finalize" />
        </Button>
      );
    }
    return (
      <DropdownButton
        bsStyle="success"
        title={<span><em className="fa fa-check" /><Translate value="deliver" /></span>}
        className="dropdownbutton"
        disabled={this.shouldDisableFinalizeButton()}
      >
        <MenuItem onSelect={() => { this.deliverSalesOrders(); }}>
          <Translate value="deliver" />
        </MenuItem>
        <MenuItem onSelect={() => { this.finalizeSalesOrders(); }}>
          <Translate value="finalize" />
        </MenuItem>
      </DropdownButton>
    );
  }

  renderButtons() {
    if (!this.state.showFinalized) {
      return (
        <ButtonToolbar className="table-buttons">
          {this.renderFinalizeButton()}
          <Button
            bsStyle="warning"
            type="button"
            onClick={(event) => { this.setCurrentSalesInvoice(event); }}
            disabled={!this.state.salesInvoices.selectedRows || this.state.salesInvoices.selectedRows.length !== 1 || !checkPermission('change_sales_invoice')}
          >
            <em className="fa fa-pencil" /><Translate value="edit" />
          </Button>
          <Button
            bsStyle="danger"
            type="reset"
            onClick={() => { this.openCheckAuthorize('remove'); }}
            disabled={this.shouldVoidButtonDisable() || !checkPermission('delete_sales_invoice')}
          >
            <em className="fa fa-trash" /><Translate value="void" />
          </Button>
          {this.renderPrint()}
          {this.renderPrintNs()}
        </ButtonToolbar>
      );
    }
    return (
      <ButtonToolbar className="pull-right">
        <Button
          bsStyle="primary"
          onClick={() => { this.setButtonStatus(false); this.props.fetchSalesInvoicesByType('released'); }}
        >
          <Translate value="show_released_si" />
        </Button>
        <Button
          bsStyle="warning"
          onClick={(event) => { this.setCurrentSalesInvoice(event); }}
          disabled={!this.state.salesInvoices.selectedRows || this.state.salesInvoices.selectedRows.length !== 1}
        >
          <em className="fa fa-pencil" /><Translate value="edit_released_si" />
        </Button>
        <Button
          bsStyle="primary"
          disabled={this.state.salesInvoices.selectedRows.length !== 1 || !checkPermission('print_sales_invoice')}
          onClick={() => { this.printForm(); }}
        >
          <em className={this.renderPrintIcon()} /><Translate value="print_si" />
        </Button>
        <a className="btn btn-primary" href={url} > <em className="fa fa-print marginRightStyle" /><Translate value="print" /></a>
      </ButtonToolbar>
    );
  }

  renderExportButton() {
    const FromDate = (this.context.router.routes[1].path === 'salesInvoice') ? this.state.fromDate : this.state.fromDate;
    const ToDate = (this.context.router.routes[1].path === 'salesInvoice') ? this.state.toDate : this.state.toDate;
    const OrderFilter = (this.context.router.routes[1].path === 'salesInvoice') ? this.props.OrderFilter : this.state.typeRadios;
    const StatusFilter = (this.context.router.routes[1].path === 'salesInvoice') ? this.props.StatusFilter : this.state.statusRadios;
    const { Days } = this.state;
    const dateRange = Days || -1;
    let status = StatusFilter;
    if (status === 'all') {
      status = '';
    } else {
      status = `&SaleStatus=${StatusFilter}`;
    }
    const { fromDate, toDate } = toFromDates(dateRange, FromDate, ToDate);
    const Company_id = this.props.selectedCompany ? this.props.selectedCompany.value : null;
    const exportUrl = `${ROOT_URL}v1/sale/sales_invoice/search/${
      OrderFilter}/export/?PostingDate__gte=${fromDate}&PostingDate__lte=${
      toDate}${status}&Bearer=${localStorage.getItem('token')}&Company_id=${Company_id}`;
    return (
      <Button
        bsStyle="success"
        className="export-to-excel"
        href={exportUrl}
        disabled={!checkPermission('print_sales_invoice')}
      >
        <em className="fa fa-download" />
        <Translate value="excel" />
      </Button>
    );
  }

  renderExportSelectedButton() {
    const invoiceIds = [];
    const { selectedRows } = this.state.salesInvoices;

    if ( selectedRows && selectedRows.length > 0) {
      selectedRows.map((row) => {
        invoiceIds.push(row.SalesInvoice_id);
      });
    }

    const exportUrl = `${ROOT_URL}v2/invoice-line-export/${invoiceIds.join(",")}?Bearer=${localStorage.getItem("token")}`

    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={(!invoiceIds || invoiceIds.length < 1)}
      >
        <em className="fa fa-print" />
        <Translate value="excel_lines" />
      </Button>
    );
  }

  renderTotal(page) {
    if (page === 'salesInvoice') {
      return (
        <span />
      );
    }
    return (
      <Panel>
        <Row className="grand-total">
          <Col xs={5} style={{ 'margin-top': '2px' }}>
            <label>
              <Translate value="rows" />:&nbsp;
              <span className="font-color-orange">{ this.state.rowsCount }</span>
            </label>
          </Col>
          <Col xs={6}>
            <Col style={{ 'margin-top': '2px' }} xs={2} xsOffset={2}>
              <span>
                <label style={{ display: 'inline-flex' }}><Translate value="grand_total" /><span className="dollar-sign"> $$</span>:</label>
              </span>
            </Col>
            <Col xs={2}>
              <Field component={DisabledInputField} placeholder={`${numberWithCommas(this.state.total)}` || 0} />
            </Col>
          </Col>
        </Row>
      </Panel>
    );
  }

  renderOrderTypeFilter = () => {
    if (!isOCM) return null;
    return <Col xs={5}>
        <Row>
          <Col xs={2} style={{ left: '-70px' }}>
            <h3 className="filter-title" style={{ whiteSpace: 'nowrap', float: 'right' }}><Translate value="type" /><span className="colon">:</span></h3>
          </Col>
          <Col xs={10} style={{ left: '-77px' }}>
          <div id="statusFilterRadios">
            {this.renderGenericOrderTypeRadios()}
          </div>
          </Col>
        </Row>
      </Col>
  }

  render() {
    let height = (this.state.tableHeight / 3 * 2 + 70).toString();

    const createDialogStyle = {
      width: '550px',
      height: '300px',
      marginLeft: '-15%',
    };
    const createPaymentMethodDialogStyle = {
      width: '600px',
      height: '360px',
      marginLeft: '-10%',
    };

    const data = Data.Selectors.getRows(this.state.salesInvoices);
    const fileName = `si-filtered-${moment().format('YYYYMMDD')}.csv`;
    const salesInvoiceTable = (this.context.router.routes[1].path === 'salesInvoice') ? ' position-relative table-collapse-fix' : 'position-relative ar-table-collapse-fix';
    const changePaymentMethodTitle = (<Translate value='payment_method_change' />);
    const printContainerTitle = (<Translate value='print_container_invoice' />);

    return (
    //---------------
    // Begin HTML
    //---------------
      <ContentWrapper>
        {/* Nav Trail */}
        <Breadcrumb>
          <Breadcrumb.Item>
            {(this.context.router.routes[1].path === 'salesInvoice') ?
              <Translate value="sales_management" />:
              <Translate value="ar_slashsign_ap" />
            }
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="sales_invoice" />
          </Breadcrumb.Item>
        </Breadcrumb> {/* End Nav Trail */}

        <Grid id="sales-invoice">
          {/* Date Range Pickers */}
          <Row>
            <Col xs={12}>
              <Panel id="date-range-picker" className="form-horizontal">
                <Row>
                  <Col xs={1}>
                    <h3 className="filter-title" style={{ whiteSpace: 'nowrap' }}><Translate value="invoice_type" /><span className="colon">:</span></h3>
                  </Col>
                  <Col xs={4}>
                    <div id="statusFilterRadios">
                      {(this.context.router.routes[1].path === 'salesInvoice') ?
                        <Field
                          name="OrderFilter"
                          component={renderTypeRadios}
                          fetching={this.props.isLoading}
                        /> :
                        this.renderGenericTypeRadios()
                      }
                    </div>
                  </Col>
                  <Col xs={1} style={{ left: '-70px' }}>
                    <h3 className="filter-title" style={{ whiteSpace: 'nowrap', float: 'right' }}><Translate value="status" /><span className="colon">:</span></h3>
                  </Col>
                  <Col xs={5} style={{ left: '-77px' }}>
                    <div id="statusFilterRadios">
                      {(this.context.router.routes[1].path === 'salesInvoice') ?
                        <Field
                          name="StatusFilter"
                          component={renderStatusRadios}
                          fetching={this.props.isLoading}
                        /> :
                        this.renderGenericStatusRadios()
                      }
                    </div>
                  </Col>
                  <Col xs={1}>
                    <h3 className="filter-title text-nowrap"><Translate value="invoice_date" /><span className="colon">:</span></h3>
                  </Col>
                  {/* <Col xs={2} /> */}
                  <Col xs={5}>
                    {
                      (this.context.router.routes[1].path === 'salesInvoice')
                        ? (dateFilterRadios({
                            handleOnClick: this.fetchSalesInvoicesByDetails,
                            setFromDate: this.setFromDate,
                            setToDate: this.setToDate,
                            setToRangeSearch: this.setToRangeSearch,
                            FromDate: this.state.fromDate,
                            ToDate: this.state.toDate,
                            Days: this.state.days,
                          })
                          ) : (
                            this.renderDatePickers()
                          )
                    }
                  </Col>
                    {this.renderOrderTypeFilter()}
                </Row>
              </Panel>
            </Col>
          </Row>
          {/* End Date Range Pickers */}

          {/* Sales Invoice History Table */}
          <Row>
            <Col xs={12}>
              <Panel className={salesInvoiceTable}>
                {this.renderButtons()}
                <div className="table-filters" style={{ zIndex: 1 }}>
                  <label className="control-label"><Translate value="select_seller" /></label>
                  { this.renderUsers() }
                  <ButtonToolbar style={{ display: 'flex' }}>
                    { this.renderExportButton() }
                    { isTN && this.renderExportSelectedButton() }
                    <CSVLink
                      data={formatExportData(data)}
                      filename={fileName}
                      className="btn btn-success export-to-excel"
                      target="_blank"
                      disabled={(this.state.salesInvoices && this.state.salesInvoices.filters && _.isEmpty(this.state.salesInvoices.filters)) || !checkPermission('print_sales_invoice')}
                    >
                      <em className="fa fa-download" />
                      <Translate value="filtered_excel" />
                    </CSVLink>
                    { isRivera && this.renderPaymentMethodChangeButton() }
                  </ButtonToolbar>
                </div>
                <div id="autosuggest-div">
                  <Row style={{ height: '30px' }}>
                    <Col xs={6}>
                      <TypeRadios value={this.state.productSearchType} handleOptionChange={this.handleOptionChange} />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={6}>
                      <Row>
                        <Col xs={12}>
                          {this.renderAutoSuggest()}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
                { this.renderTable() }
              </Panel>
              { this.renderTotal(this.context.router.routes[1].path) }
            </Col>
          </Row> {/* Sales Invoice History Table */}

          {/* Sale Invoice Details */}
          {
            (this.context.router.routes[1].path === 'salesInvoice') ?
              <Row>
                <Col xs={12}>
                  <h2><Translate value="sale_invoice_details" /></h2>
                  <Panel className="details-table-collapse-fix">
                    {this.renderSalesInvoiceDetailTable() }
                  </Panel>
                </Col>
              </Row>
              :
              <span />
          }
          {/* Sale Invoice Details */}
          {this.renderSalesInvoiceIFrame()}
          {this.renderSalesReturnIFrame()}
          {this.renderSalesInvoiceIFrameIsLoadedNs()}
          {this.renderSalesInvoiceIFrameReturnNs()}
        </Grid>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.checkAuthorizeOpen}
          onCloseClicked={this.closeCheckAuthorize}
        >
          <ConfirmActionModal
            case='confirmPassword'
            closeC={this.checkAuthorize}
            checkPasswordFailure={this.props.checkPasswordFailure}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.verifyPasscodeOpen}
          onCloseClicked={this.closeVerifyPasscode}
        >
          <VerifyPasscodeModal
            closeConfirm={this.handleVerifyPassocdeModalClose}
          />
        </SkyLightStateless>
        <SkyLightStateless dialogStyles={createPaymentMethodDialogStyle} isVisible={this.state.paymentMethodModalVisibility} onCloseClicked={() => { this.closePaymentMethodModal(); }} title={changePaymentMethodTitle}>
          <PaymentMethodModal 
            salesOrder={this.state.salesInvoices.selectedRows}
            successSaved={this.handleSOPaymentMethodSaved}
          />
        </SkyLightStateless>
      </ContentWrapper>
      //---------------
      // End HTML
      //---------------
    );
  }
}

export default SalesInvoice;

// Show Finalized Invoices
// <Button
//     className="btn btn-primary"
//     onClick={() => {this.setButtonStatus(true); this.props.fetchSalesInvoicesByType("finalized");}}><Translate value="show_finalized_si" />
// </Button>



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/salesInvoice.jsx